import React, { useContext } from "react";
import styled from "styled-components";
import { Button } from "../../Theme/Hyper";
import { UIContext } from "../../contexts/UIContext";
import CountriesList from "../Countries/CountriesList";

const Main = styled.div`
  padding-top: 52px;
  margin-bottom: 52px;
`;

export default function () {
  const { selectedSeason } = useContext(UIContext);
  return (
    <Main>
      {/* <Button
        onClick={() => {
          fetch(
            "http://localhost:8082/opta/countries/" + selectedSeason.opta_ID
          );
        }}
      >
        Update OPTA
      </Button> */}
      <CountriesList />
    </Main>
  );
}
